import { Injectable } from '@angular/core';
import { AngularFirestore, DocumentReference } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Categoria } from '../models/categoria';
import { CategoriaViewModel } from '../models/categoria-view-model';

@Injectable({
  providedIn: 'root'
})
export class CategoriaService {

 constructor(private db: AngularFirestore) { }

 private categoriaCollectionName = 'categorias';

 getCategorias(): Observable<firebase.default.firestore.QuerySnapshot> {
  return this.db.collection<Categoria>(this.categoriaCollectionName, ref => ref.where("_lgBaja", "==", false).orderBy('orden', 'asc')).get();
 }

 saveCategoria(categoria: Categoria): Promise<DocumentReference<any>> {
  return this.db.collection(this.categoriaCollectionName).add(categoria);
 }

 editCategoria(categoria: CategoriaViewModel): Promise<void>{
  return this.db.collection(this.categoriaCollectionName).doc(categoria.id).update(categoria);
 }

 editCategoriaPartial(id: string, obj: Object): Promise<void>{
  return this.db.collection(this.categoriaCollectionName).doc(id).update(obj);
 }

 deleteCategoria(idCategoria: string): Promise<void>{
  return this.db.collection(this.categoriaCollectionName).doc(idCategoria).delete();
 }
}
